import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, ModuleWithProviders, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import {
  AbstractAuthHttp, AppConfigService, AUTH_RESOURCES_CONFIG, AuthHttp, AuthParams, BreadcrumbModule, CanActivateKeyCloak, CanActivateRoute, CanDeactivateGuard,
  EloNotificationsModule, ErrorModule, FeatureModuleStateService, FeaturesGroupModule, GlobalExceptionHandlerService, HeaderModule, HttpClient,
  HttpClientInterceptorToken, KeycloakAuthHttp, KeycloakInterceptor, KeycloakToken, PageNotFoundModule, RouterService, SectionModule, SidebarModule,
  SpinnerInterceptor, SpinnerModule, UrlResolver
} from '@elotech/angular-common';
import { HeaderOverrideService } from '../../../folha-pagamento/src/http/interceptor/header-data-operacao.service';
import { HeaderParamsFolhaInterceptor } from '../../../folha-pagamento/src/http/interceptor/header-params-folha.interceptor';
import { ServidorSelecionadoService } from '../common/components/funcionario-sidebar/servidor-selecionado.service';
import { EntidadeService } from '../common/services/entidade.service';
import { PortalServidorService } from '../common/services/portal-servidor.service';
import { environment } from '../environments/environment';
import { UsuarioService } from '../usuario/usuario.service';
import { CompetenciaService } from '../../../folha-pagamento/src/common/components/competencia/competencia.service';

export class UrlResolverLogin extends UrlResolver {
  constructor() {
    super(environment.apiUrl);
  }
}

export function authInterceptorFactory(headerDataOperacaoService: HeaderOverrideService, keyCloakService: KeycloakAuthHttp, authParams: AuthParams) {

  const keycloakParams = new HeaderParamsFolhaInterceptor(keyCloakService, headerDataOperacaoService);

  return keycloakParams;
}

export function headerParamsFactory(http: HttpClient, authParams: AuthParams, router: Router, keycloakService: KeycloakAuthHttp) {

  const keycloakHeaderParams = new KeycloakInterceptor(router, keycloakService);

  return keycloakHeaderParams;
}

export function canActivateRouteFactory(authHttp: AuthHttp, router: Router, keycloakService: KeycloakAuthHttp,
                                        usuarioService: UsuarioService) {
  return new CanActivateKeyCloak(keycloakService, router);
}

export function createAuthResource() {
  return Object.assign({},
    {
      isDev: !environment.production,
      app: 'rh'
    });
}

@NgModule({
  imports: [CommonModule],
  exports: [
    CommonModule,
    HttpClientModule,
    ErrorModule,
    PageNotFoundModule,
    HeaderModule,
    FeaturesGroupModule,
    SpinnerModule,
    EloNotificationsModule,
    SidebarModule,
    SectionModule,
    BreadcrumbModule
  ]
})
export class SharedModule {

  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        PortalServidorService,
        HeaderOverrideService,
        ServidorSelecionadoService,
        CompetenciaService,
        AuthParams,
        AuthHttp,
        HttpClient,
        CanActivateKeyCloak,
        CanDeactivateGuard,
        KeycloakAuthHttp,
        {
          provide: CanActivateRoute,
          useClass: CanActivateKeyCloak
        },
        {
          provide: HttpClientInterceptorToken,
          useClass: KeycloakInterceptor,
          multi: true
        },
        FeatureModuleStateService,
        SpinnerInterceptor,
        {
          provide: HttpClientInterceptorToken,
          useExisting: SpinnerInterceptor,
          multi: true
        },
        {
          provide: KeycloakToken,
          useClass: KeycloakAuthHttp
        },
        AppConfigService,
        EntidadeService,
        RouterService,
        {
          provide: HttpClientInterceptorToken,
          useFactory: authInterceptorFactory,
          deps: [HeaderOverrideService, KeycloakAuthHttp],
          multi: true
        },
        {provide: AbstractAuthHttp, useClass: KeycloakAuthHttp},
        {provide: UrlResolver, useClass: UrlResolverLogin},
        {provide: ErrorHandler, useClass: GlobalExceptionHandlerService},
        {provide: AUTH_RESOURCES_CONFIG, useFactory: createAuthResource}

      ]
    };
  }
}
